export default function LocaleSection({ id, title, paras = [], bullets = [], children }) {
  return (
    <section id={id} className="mb-16">
      <h2 className="font-inter font-black text-3xl md:text-4xl tracking-[-0.03em] text-foreground mb-6">{title}</h2>
      {paras.map((p, i) => (
        <p key={i} className="text-muted-foreground font-inter leading-relaxed mb-4">{p}</p>
      ))}
      {bullets.length > 0 && (
        <ul className="space-y-3 mt-4">
          {bullets.map((b) => (
            <li key={b} className="flex gap-3 text-muted-foreground font-inter leading-relaxed">
              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0" aria-hidden="true" />
              <span>{b}</span>
            </li>
          ))}
        </ul>
      )}
      {children}
    </section>
  );
}